const getSegmentServicesByTrip = (services, origin, destination) =>
  services.filter(
    ({ trip, segment }) =>
      !!trip && !!segment && trip.origin === origin && trip.destination === destination,
  );

export default getSegmentServicesByTrip;
